import { recaptchaService } from '@project/services';

export const useVerifyRecaptcha = (token: string) => recaptchaService.verifyRecaptcha(token);
